import "./Trend.scss"
import React, { Component } from "react"
import { toJS } from "mobx"
import { observer } from "mobx-react"
import { trendStore } from "../stores"
import { Chart } from "../lib"
import TrendFilters from "./TrendFilters"
import { getTopStage } from "../assess/survey-utils"

class Trend extends Component {
  componentDidMount() {
    trendStore.loadTrendsForFilters()
  }

  render() {
    const questions = toJS(trendStore.averages)
    return (
      <div className="Trend">
        <Chart
          questions={questions}
          phase={getTopStage(questions)}
          averageScoreTooltip={false}
          hideTopStage={true}
        />
        {trendStore.count < 1 ? (
          <div className="Trend_blank">
            <h2>Not enough data</h2>
          </div>
        ) : (
          <div className="Trend_count">
            <h5>Showing results for {trendStore.count} churches</h5>
          </div>
        )}
        <TrendFilters />
      </div>
    )
  }
}

Trend.displayName = "Trend"

export default observer(Trend)



// WEBPACK FOOTER //
// ./src/home/Trend.js